
import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import { getBSRSToken, getIsIntegration } from './'

const Auth = {
	isAuthenticated: () => {
		const bsrsToken = getBSRSToken()
		// const serviceToken = getAccessToken()

		return !!bsrsToken /*&& !!serviceToken*/
	},
	isIntegration: () => {
		// const o365Token = getO365Token()
		const isIntegration = getIsIntegration()
		return !!isIntegration
	}
}

const PrivateRoute = ({ component: Component, ...rest }) => (
	<Route {...rest} render={(props) => {
		if (Auth.isAuthenticated() === false && props.match.url !== "/login") {
			return <Redirect to='/login' />
		}

		if (Auth.isIntegration() === false && props.match.url !== "/integration") {
			return <Redirect to='/integration' />
		}

		if (Component !== undefined) {
			return <Component {...props} />
		} else {
			return <Redirect to='/' />
		}
	}} />
)

const PublicRoute = ({ component: Component, ...rest }) => {
	return <Route {...rest} render={(props) => {

		if (Auth.isAuthenticated() === true && props.match.url === "/login") {
			return <Redirect to='/' />
		}

		if (Component !== undefined) {
			return <Component {...props} />
		} else {
			return ""
		}
	}} />
}

export {
	PrivateRoute,
	PublicRoute,
	Auth,
}


// WEBPACK FOOTER //
// ./src/lib/routePermission.js